module.exports = __webpack_public_path__ + "img/clean.33930f29.png";